// extracted by mini-css-extract-plugin
export default {"root_secondary":"styles_root_secondary__r5rTg","header":"styles_header__RSJ3y","title":"styles_title__Urvlq","caption":"styles_caption__tQveh"};